import React from 'react';

const ArrowUpIconSVGR = () => (
  <svg
    aria-hidden='true'
    className=''
    fill='currentColor'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    transform='matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)'
  >
    <title>Expand</title>
    <path d='M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z' />
  </svg>
);

export default ArrowUpIconSVGR;
